var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analyse-container"},[_c('div',{staticClass:"analyse-container-img"},[_c('img',{staticStyle:{"width":"12.5rem"},attrs:{"src":require("@/assets/img/gjh/weitu.png")}}),_c('p',{staticStyle:{"margin-top":"1.25rem"}},[_vm._v(_vm._s(_vm.desc)+"暂无数据")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }